import React from "react"
import { injectIntl } from "react-intl"
import ActivityFeedComponent from "./activity-feed/components/ActivityFeedComponent"

const DashboardPage = () => {
    return (
        <>
            <ActivityFeedComponent />
        </>
    )
}

export default injectIntl(DashboardPage)



// WEBPACK FOOTER //
// ./src/dashboard/DashboardPage.tsx